
import {Checkbox} from 'vue-checkbox-radio'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Sticky from 'vux/src/components/sticky/index.vue'

import {fetchCart, createOrder} from '@/api/cart'
import {deleteFromCart} from '@/api/resource'
import {mapGetters} from 'vuex'

export default {
computed: {
...mapGetters([
'taxonomyList',
'profile'
])
},
data () {
return {
activeIndex: 0,
totalPrice: 0,
chargePrice: 0,
cartData: [],
selectAll: true,
selelctAllValue: 'all',
touchModel: {
startX: 0,
moveX: 0,
endX: 0,
disX: 0,
currentIdx: 0
},
orderNumber: 0,
iconLink: ''
}
},
components: {
Checkbox,
Tab,
TabItem,
Swipeout,
SwipeoutItem,
SwipeoutButton,
CheckIcon,
Sticky
},
methods: {

tabClick (idx) {
this.$router.push('/cart?tab=' + idx)
this.activeIndex = idx
this.getData()
},

getTabStatus () {

if (this.$route.query.tab) {
this.activeIndex = parseInt(this.$route.query.tab)
this.getData()
} else {
this.getData()
}
},
mathTotalPrice () {
let totalPrice = 0
const chargeRatio = this.profile.price_level.service_rate
this.cartData.map(item => {
if (item.checked) {
totalPrice = totalPrice + parseInt(item.price)
}
})
this.chargePrice = (totalPrice * chargeRatio).toFixed(2)
this.totalPrice = (totalPrice * (1 + chargeRatio)).toFixed(2)
},
checkboxChange (idx) {
this.cartData[idx].checked = !this.cartData[idx].checked
this.mathTotalPrice()
},
checkboxAllChange () {
const checkboxItems = this.cartData
if (this.selectAll === true) {
this.selectAll = false
for (let i = 0, lenI = checkboxItems.length; i < lenI; ++i) {
checkboxItems[i].checked = false
}
} else {
this.selectAll = true
for (let i = 0, lenI = checkboxItems.length; i < lenI; ++i) {
checkboxItems[i].checked = true
}
}
this.cartData = checkboxItems
this.mathTotalPrice()
},
getData () {
this.cartData = []
fetchCart(this.taxonomyList[this.activeIndex].tabType).then(resp => {
this.orderNumber = resp.data.length
this.cartData = resp.data.map(data => {
const price = parseFloat(data.price)
return {
...data,
price,
checked: true
}
})
this.mathTotalPrice()
}).catch((e) => console.log('error', e))
},


handleCreateOrder () {
const cartIdsArray = []
this.cartData.map(item => {
if (item.checked) {
cartIdsArray.push(item.item_id)
}
})
const cartIds = cartIdsArray.join()
createOrder(cartIds, this.taxonomyList[this.activeIndex].tabType).then(resp => {
this.$router.push('/order')
}).catch((e) => console.log('error', e))
},


handleCleanCart () {
const cartIds = this.cartData.map(item => item.item_id).join()
console.log(cartIds)
deleteFromCart(cartIds).then(resp => {
this.getData()
}).catch((e) => console.log('error', e))
},


handleRemoveFromCart (id) {
deleteFromCart(id).then(resp => {
this.getData()
}).catch((e) => console.log('error', e))
}
},
mounted () {
this.getTabStatus()
}
}



// WEBPACK FOOTER //
// ./src/pages/cart/index.vue